import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Country, NewCountry } from "src/app/domain/models/Country";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export abstract class CountryGateway {
    abstract getAll(): Observable<Array<Country>>
    abstract getById(id: number): Observable<Country>
    abstract create(country: NewCountry): Observable<Country>
    abstract update(country: Country): Observable<Country>
    abstract delete(id: number): Observable<Country>
    abstract getAllByIsOrigin(isOrigin: boolean): Observable<Array<Country>>
    abstract getAllPaged(pageNumber: number, pageSize: number): Observable<PageResult<Country>>
}
